import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Table, Pagination, Col, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
import 'antd/dist/antd.css';
import 'ant-design-pro/dist/ant-design-pro.css';
import { spStates } from '../../config/constants/contractStates';
import date from '../../helpers/date';
import { LIST_PAGINATE_CONTRACTS, PERSIST_PAGESIZE } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const { formatString } = date;
const { Text } = Typography;

const DocumentDetailTable = ({
  document,
  listContracts,
  statusName,
  pageSize,
  persistPageSize,
  startDate,
  endDate,
  activeTabWithFilter
}) => {

  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  useEffect(() => {
    setStart(startDate !== '' ? formatString(startDate) : '');
    setEnd(startDate !== '' ? formatString(endDate) : '');
  }, [startDate, endDate]);

  /**
   * Array of objects with table column information
   */
  const columns = [
    {
      title: 'ID Contrato',
      dataIndex: 'id',
      width: 200,
    },
    {
      title: 'Propietario',
      dataIndex: 'owner',
    },
    {
      title: 'Rut',
      dataIndex: 'rut',
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
    },
    {
      title: 'Id de transacción',
      dataIndex: 'transactionId',
    },
    {
      title: 'Monto',
      dataIndex: 'total',
    },
    {
      title: 'Estado de contrato',
      dataIndex: 'state',
    },
    {
      title: 'Ver documentos',
      dataIndex: 'action',
      width: 150,
      fixed: 'right',
    },
  ];

  const data = document.docs && document.docs[0]
    ? document.docs.map((document, index) => ({
      key: index,
      id: document.contractId,
      owner: document.owner.nombre,
      rut: document.owner.rut.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      date: formatString(document.createdAt),
      transactionId: document.payment ? document.payment.buyOrder : 'NA',
      total: document.payment ? `$${document.payment.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` : 'NA',
      state: spStates(document.estado),
      action: <NavLink to={`/contracts/contract_detail/${document._id}`}>Ver detalle</NavLink>,
    }))
    : [];

  const PaginationTable = () => {
    const getMoreDocs = (page, selectedPageSize) => {
      persistPageSize({ page, selectedPageSize });
      if (statusName === activeTabWithFilter) {
        listContracts({
          limit: selectedPageSize,
          page: page,
          statusName: statusName,
          startDate: startDate,
          endDate: endDate
        });
      } else {
        listContracts({
          limit: selectedPageSize,
          page: page,
          statusName: statusName,
          startDate: '',
          endDate: ''
        });
      }
    };

    return (
      <Pagination
        defaultCurrent={document.page}
        total={!document.totalDocs ? 1 : document.totalDocs}
        onChange={getMoreDocs}
        pageSize={pageSize}
      />
    );
  };

  return (
    <>
      <div className="site-card-wrapper mb-2">
        {start !== '' &&
          <Text strong mark>Contratos filtrados entre {start} y {end}</Text>
        }
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: 1300, y: 400 }}
          pagination={false}
        />
      </div>
      <Col xs={24} className="d-flex justify-content-end">
        <PaginationTable />
      </Col>
    </>
  );
};

DocumentDetailTable.propTypes = {
  document: PropTypes.object.isRequired,
  listContracts: PropTypes.func.isRequired,
  statusName: PropTypes.string.isRequired,
  pageSize: PropTypes.number.isRequired,
  persistPageSize: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  activeTabWithFilter: PropTypes.string,
};

const data = (state) => ({
  pageSize: state.contract.persistedPageSize,
  startDate: state.contract.startDate,
  endDate: state.contract.endDate,
  activeTabWithFilter: state.contract.activeTabWithFilter,
});

const action = (dispatch) => ({
  listContracts: (params) => dispatch({ type: LIST_PAGINATE_CONTRACTS, payload: { params, resource: RESOURCE.GET_CONTRACT_LIST } }),
  persistPageSize: (params) => dispatch({ type: PERSIST_PAGESIZE, payload: params }),
});

export default connect(data, action)(DocumentDetailTable);